<template>
  <UeModal
    name="share_survey_spotlight_modal"
    title="Share Survey Spotlight"
    @before-open="beforeOpen"
    :containerClass="freestanding ? 'share-modal freestanding' : 'share-modal'"
    :showCloseButton="!freestanding"
    ref="shareModal"
  >
    <div v-if="surveySpotlight">
      <div class="mb-3">Download a single page PDF</div>
      <div>
        <b-button v-if="downloading" disabled block>Generating&hellip;</b-button>
        <b-button @click="downloadSpotlight" block variant="primary" v-else>Download</b-button>
      </div>
    </div>
  </UeModal>
</template>
<script lang="ts">
import { generateShareLink } from '@lib/share_link'
import { AxiosResponse } from 'axios'
import { trackEvent, assetEventData } from '@lib/tracking'
import { renderSurveySpotlight } from '@app/api'

export default {
  props: ['freestanding'],
  data() {
    return {
      surveySpotlight: null,
      downloading: false,
    }
  },
  methods: {
    downloadSpotlight() {
      trackEvent('asset embed code copied', assetEventData(this.surveySpotlight))

      this.downloading = true
      renderSurveySpotlight(this.surveySpotlight.identifier, { filetype: 'pdf' })
        .then((r: AxiosResponse) => {
          return r.data.download_url
        })
        .then((url: string) => this.attemptPopUp(url))
        .catch(() => alert('Darn! Something went wrong. Please try again.'))
        .finally(() => (this.downloading = false))
    },
    attemptPopUp(url: string) {
      const newWindow = window.open(url, '_blank')
      try {
        newWindow.focus()
      } catch (e) {
        // Trying to `window.open` a PDF attachment file seems to trigger pop-up blockers on Chrome
        alert(
          'It looks like a pop-up blocker prevented the download window from opening. Please allow them for this site.',
        )
      }
    },
    beforeOpen(e) {
      this.surveySpotlight = e.params.surveySpotlight
    },
    embedSnippet() {
      return `<iframe src='${generateShareLink(this.surveySpotlight.identifier)}' frameBorder='0'></iframe>`
    },
  },
}
</script>
